import { createFileRoute } from '@tanstack/react-router';
import VendorContactView from '../admin/vendor-contacts/view';
export const Route = createFileRoute('/admin/vendors/$vendorGuid/contacts/')({
  component: VendorContactView,
});
